import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 展示开票信息
export function showInvoiceMessage(params) {
  return axios.request({
    url: urlObj.crm + 'crm/acceptInvoice/showInvoiceMessage',
    method: 'get',
    params
  })
}
// 新增开票信息
export function addInvoiceMessage(data) {
  return axios.request({
    url: urlObj.crm + 'crm/acceptInvoice/addInvoiceMessage',
    method: 'post',
    data
  })
}
// 修改开票信息
export function updateInvoiceMessage(data) {
  return axios.request({
    url: urlObj.crm + 'crm/acceptInvoice/updateInvoiceMessage',
    method: 'put',
    data
  })
}
// 删除开票信息
export function delInvoiceMessage(params) {
  return axios.request({
    url: `${urlObj.crm}crm/acceptInvoice/deleteInvoice`,
    method: 'DELETE',
    params
  })
}
// 设置默认
export function updateIsDefault(data) {
  return axios.request({
    url: urlObj.crm + 'crm/acceptInvoice/updateIsDefault',
    method: 'put',
    data
  })
}
